module.exports = __webpack_public_path__ + "img/softwareeng.7b4625dd.svg";